module.exports = __webpack_public_path__ + "static/media/clueMM-thumb.b906ff9d.jpg";